import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from 'react-pdf';
import TNC from "../../../../../../libs/api/services/TNC";
// Use the bundled worker entry so the worker is included by the app build and doesn't need to be fetched from CDN.
// Place a copy of the appropriate worker file in the app's public folder and point to it.
// We'll copy `node_modules/pdfjs-dist/build/pdf.worker.min.mjs` -> `public/pdf.worker.min.mjs`.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

export default function TermsAndConditionsComponent({ defaultValues, onUserInput }) {
  const [tncs, setTncs] = useState();
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  useEffect(() => {
    TNC.GetTermsAndConditions()
      .then((res) => {
        setTncs(res);
        setLoading(false);
      })
      .catch((e) => console.error("Error fetching TNCs:", e));
  }, []);
  if (loading) return <div>Loading...</div>;
  const activeTnc = tncs && tncs.find((x) => x.isDeleted === false);

  return (activeTnc && <>
    <Document file={{ url: `data:application/pdf;base64,${activeTnc.data}` }} onLoadSuccess={onDocumentLoadSuccess}>
      <Page pageNumber={pageNumber} />
    </Document>

    <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
      <button type="button" onClick={() => setPageNumber(Math.max(1, pageNumber - 1))} disabled={pageNumber <= 1}>
        Previous
      </button>
      <button type="button" onClick={() => setPageNumber(Math.min(numPages || 1, pageNumber + 1))} disabled={!numPages || pageNumber >= numPages}>
        Next
      </button>
    </div>

    <p>
      Page {pageNumber} of {numPages}
    </p>
    {/* <embed
      className='flex-grow-1'
      style={{ height: '100%', width: '100%' }}
      src={`data:application/pdf;base64,${activeTnc.data}`}
      type='application/pdf' /> */}
  </>);
}
